import { render, staticRenderFns } from "./CreateGptProfile.vue?vue&type=template&id=3ff6f8bc&scoped=true"
import script from "./CreateGptProfile.vue?vue&type=script&lang=js"
export * from "./CreateGptProfile.vue?vue&type=script&lang=js"
import style0 from "./CreateGptProfile.vue?vue&type=style&index=0&id=3ff6f8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff6f8bc",
  null
  
)

export default component.exports